// ✅ FormInput.jsx
import React from "react";
import PropTypes from "prop-types";

const FormInput = (
  {
    field,
    value,
    handleChange,
    error = null,
    className = "",
  }) => {

  const handleInputChange = (e) => {
    // Enforce max for number inputs — clamp value if it exceeds field.max
    if (field.type === "number" && field.max !== undefined && field.max !== null) {
      const numVal = Number(e.target.value);
      if (numVal > Number(field.max)) {
        e.target.value = field.max;
      }
    }
    handleChange(e);
  };

  return (
    <div className={`${className} ${field.fieldSize || "col-12"}`} >
      {!field.lableHide && (
        field.label ? (
          <label className="form-label text-muted">
            {field.label}{" "}
            {field.required && <span className="text-danger small">*</span>}
          </label>
        ) : (
          <label className="mt-sm-4"></label>
        )
      )}

      <input
        type={field.type || "text"}
        className={`form-control ${error ? "border-danger" : ""}`}
        name={field.name}
        value={value}
        onChange={handleInputChange}
        placeholder={field.placeholder || ""}
        required={field.required || false}
        disabled={field.disabled || false}
        readOnly={field.readOnly || false}
        min={field.min !== undefined ? field.min : undefined}
        minLength={field.minLength || undefined}
        max={field.max !== undefined && field.max !== null ? field.max : undefined}
        maxLength={field.maxLength || undefined}
        accept={field.accept || ""}
        step={field.step || ""}
      />

      {error && <span className="text-danger">{error}</span>}
    </div>
  );
};

FormInput.propTypes = {
  value: PropTypes.any,
  handleChange: PropTypes.func,
  error: PropTypes.any,
  className: PropTypes.string,
  field: PropTypes.object,
};

export default FormInput;